import { NgModule } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FlexModule } from '@ngbracket/ngx-layout';
import { MatButtonModule } from '@angular/material/button';
import { FuseSharedModule } from '@fuse/shared.module';
import { SharedModule } from '@shared/shared.module';
import { AvvNoticeComponent } from './avv-notice.component';

@NgModule({
    declarations: [AvvNoticeComponent],
    imports: [
        FuseSharedModule,
        SharedModule,

        DragDropModule,
        FlexModule,

        MatToolbarModule,
        MatIconModule,
        MatDialogModule,
        MatButtonModule,
    ],
    exports: [AvvNoticeComponent]
})
export class AvvNoticeModule {

}
